export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-map-pin-user-line',
      title: '地域密着型',
      description: '逗子・葉山地域に特化し、地域の特性を理解したきめ細やかなサービスを提供しています。'
    },
    {
      icon: 'ri-time-line',
      title: '柔軟な対応',
      description: 'ご利用者様のライフスタイルに合わせた柔軟なスケジュール調整が可能です。'
    },
    {
      icon: 'ri-shield-check-line',
      title: '安心の体制',
      description: '24時間連絡可能な体制を整え、緊急時にも迅速に対応いたします。'
    }
  ];

  return (
    <section className="py-24 bg-gray-50 observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12">
        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-16 text-center">
          事業所の特徴
        </h2>

        <div className="grid md:grid-cols-3 gap-12 max-w-5xl mx-auto">
          {features.map((feature, index) => (
            <div key={index} className="text-center">
              <div className="w-20 h-20 bg-cyan-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${feature.icon} text-4xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>
              
              <p className="text-gray-700 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
